module.exports = __webpack_public_path__ + "img/collaborate_53.5987af35.jpg";